module.exports = __webpack_public_path__ + "img/2.10c78b47.jpg";